import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0 4rem 0;
`;

export const Content = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Link = Styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  width: fit-content;
  padding: 1.5rem;
  background-color: rgb(17, 16, 14);
  color: rgb(255, 255, 255);
  text-decoration: none;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 1rem;
  }
`;

export const Illustration = Styled.img`
  width: 3.75rem;
  height: 3.75rem;
`;

export const Message = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  padding-right: 1rem;
`;

export const Tagline = Styled.span`
  font-size: 1rem;
  line-height: 1.375rem;
  letter-spacing: -0.1px;
`;

export const Title = Styled.p`
  font-size: 1.25rem;
  line-height: 1.875rem;
  letter-spacing: -0.1px;
  margin: 0;
`;
